export const WHATSAPP_NUMBER = "6588772688";
